module.exports = {
    ch: '零一二三四五六七八九'
    ,ch_u: '個十百千萬億'
    ,ch_f: '負'
    ,ch_d: '點'
}